import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from '../styles';

export interface HeaderIconProps {
  className?: string;
}

export const HeaderIcon: FC<HeaderIconProps> = ({ children, className }) => {
  const classes = useStyles();
  return <div className={classNames(classes.headerIcon, className)}>{children}</div>;
};

export default HeaderIcon;
